import { TextDynamicAnimationBase } from './TextDynamicAnimationBase';
import type { TextDynamicGraphicRenderer } from './TextDynamicGraphicRenderer';

/**
 * Dynamic animation specific for a dynamic graphic. (Dynamic graphics are the graphics
 * built on text and automatically adapt to the text content).
 */
export class TextDynamicGraphicAnimationRenderer<
    PropertyType extends string = string,
> extends TextDynamicAnimationBase<PropertyType> {
    /**
     * Dynamic graphic animations are based on the shapes within a graphic, which valuesToAnimate
     * is already based on. So we extract the values directly and apply them.
     */
    spreadAnimatedGraphicValuesToLevels() {
        this.computedValues = this.valuesToAnimate.map((value) => value.value);
    }

    /**
     * Get the number of objects drawn for the given level when animating dynamic graphics.
     * This is important to know for how many values there should be to animate.
     */
    getNumberOfLevelObjectsForGraphics(graphic: TextDynamicGraphicRenderer): number {
        return graphic._numberOfShapes;
    }
}
